import * as pdfjsLib from 'pdfjs-dist';

// CRA / Webpack compatible worker
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

export async function convertPdfToImage(file) {
  const arrayBuffer = await file.arrayBuffer();

  const pdf = await pdfjsLib.getDocument({
    data: arrayBuffer,
  }).promise;

  const page = await pdf.getPage(1);

  const viewport = page.getViewport({
    scale: 2,
  });

  const canvas = document.createElement('canvas');

  canvas.width = viewport.width;
  canvas.height = viewport.height;

  const context = canvas.getContext('2d');

  await page.render({
    canvasContext: context,
    viewport,
  }).promise;

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Failed to convert PDF'));
          return;
        }

        resolve(
          new File([blob], file.name.replace(/\.pdf$/i, '.png'), {
            type: 'image/png',
          })
        );
      },
      'image/png',
      0.95
    );
  });
}
